module.exports = __webpack_public_path__ + "img/sceneIcon4-1.15f393a3.png";